import { PayloadAction } from '@reduxjs/toolkit';

import { GangSheetState } from 'editor/src/store/gangSheet/types';

const setAllowRotateReducer = (state: GangSheetState, action: PayloadAction<boolean>) => {
  state.allowRotate = action.payload;
};

export default setAllowRotateReducer;
